<content *ngIf="dataGrid">
    <section class="entry-inline-framed" *ngIf="(!showPais && desPais) || (!showDenominacion && desDenominacion) || (!showEtiquetador && desEtiquetador)">
        <label *ngIf="!showPais && desPais">{{'centralEstadisticas.pais' | translate}} {{desPais}} </label>
        <label *ngIf="!showDenominacion">{{'centralEstadisticas.denominacion' | translate}} {{desDenominacion}}</label>
        <label *ngIf="!showEtiquetador">{{'centralEstadisticas.etiquetador' | translate}} {{desEtiquetador}}</label>
    </section>
    <table>
        <thead>
            <tr>
                <th class="string" *ngIf="showPais">{{'global.pais' | translate}}</th>
                <th class="string" *ngIf="showDenominacion">{{'centralEstadisticas.grid.denominacion' | translate}}</th>
                <th class="string" *ngIf="showCampanya">{{'centralEstadisticas.grid.campanya' | translate}}</th>
                <th class="string" *ngIf="showEtiquetador">{{'centralEstadisticas.grid.numEtiquetador' | translate}}</th>
                <th class="string" *ngIf="showPorcentaje">{{'centralEstadisticas.grid.porcentaje' | translate}}</th>
            </tr>
        </thead>
        <tbody *ngFor="let row of dataGrid; let i = index">
            <tr *ngIf="i < lastItemList && i >= firstItemList">
                <td class="string" *ngIf="showPais">{{row.desPais}}</td>
                <td class="string" *ngIf="showDenominacion">{{row.desDenominacion ? row.desDenominacion : row.strNumDenominaciones}}</td>
                <td class="string" *ngIf="showCampanya">{{row.anyo}}</td>
                <td class="centered" *ngIf="showEtiquetador">{{row.numEtiquetadores ? row.numEtiquetadores : row.numero}}</td>
                <td class="centered" *ngIf="showPorcentaje">{{row.porcentajeEtiquetadores ? row.porcentajeEtiquetadores : row.porcentaje}}%</td>
            </tr>
        </tbody>
        <tfoot *ngIf="!dataGrid || (dataGrid && dataGrid.length < 1)">
            <tr>
                <td colspan="4">
                    {{'global.noContent' | translate}}
                </td>
            </tr>
        </tfoot>
    </table>
    <app-paginator
        *ngIf="(dataGrid && dataGrid.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
</content>
<footer *ngIf="dataGrid" class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
